// extracted by mini-css-extract-plugin
export default {"pageTitle":"PageTitle_pageTitle__UHtLB","status":"PageTitle_status__5epsj"};